/**
 * Presentational component for changing the display name.
 */
import { type HoursOfOperation } from '@/types/HoursOfOperation';
import SectionTitle from './SectionTitle';
import TimeSelect from '@/components/time/TimeSelect';
export default function ChangeOpenAndCloseSection({
  hoursOfOperation,
  handleHoursOfOperationTime,
}: {
  hoursOfOperation: HoursOfOperation;
  handleHoursOfOperationTime: (dateStr: string, isOpen: boolean) => void;
}): JSX.Element {
  return (
    <section>
      <SectionTitle title="Change Open And Close Times" />
      <div className="flex flex-wrap w-full gap-4 border-b-2 border-gray py-4">
        <div className="flex flex-col">
          Open
          <TimeSelect
            onChange={(dateStr: string) => {
              handleHoursOfOperationTime(dateStr, true);
            }}
            dataCy="day-part-start-time-input"
            value={hoursOfOperation.open}
          />
        </div>
        <div className="flex flex-col">
          Close
          <TimeSelect
            onChange={(dateStr: string) => {
              handleHoursOfOperationTime(dateStr, false);
            }}
            dataCy="day-part-start-time-input"
            value={hoursOfOperation.close}
          />
        </div>
        <div className="flex flex-col">
          <label>Clear Open and Close</label>
          <button
            className="btn bg-rose-500 hover:bg-rose-600 text-white"
            onClick={() => {
              handleHoursOfOperationTime('', true);
              handleHoursOfOperationTime('', false);
            }}
          >
            Clear
          </button>
        </div>
      </div>
    </section>

  );
}
